import { ErrorPlatformEvent, assign } from '@monofront/xstate-v4';
import {
  CheckoutCartMachineContext,
  GetCheckoutCartSuccessEvent,
  StartCheckoutEvent,
} from './types';

export const assignUserReady = assign<CheckoutCartMachineContext>({
  isUserReady: true,
});

export const assignCart = assign<
  CheckoutCartMachineContext,
  GetCheckoutCartSuccessEvent
>({
  checkoutCartId: (_, event) => event.data.cart.id,
  checkoutCart: (_, event) => event.data.cart,
});

export const assignProducts = assign<
  CheckoutCartMachineContext,
  StartCheckoutEvent
>({
  products: (_, event) => event.products,
});

export const assignError = assign<
  CheckoutCartMachineContext,
  ErrorPlatformEvent
>({
  errors: (_, event) => (Array.isArray(event.data) ? event.data : [event.data]),
});
